<template>
	<div class='main' :style="{ height: mainHeight }">
		<!-- 顶部菜单 -->
		<div class="top-tabbar">
			<div class='top-tabbar-content' :class="isShowFullBrand?'top-tabbar-border':''">
				<!-- 顶部分配和搜索框 -->
				<el-row>
					<el-col :span="3">
						<img class="mall-logo" v-if="mallLogo" :src="$utils.setImg(mallLogo)" />
					</el-col>
					<el-col :span="2">
					</el-col>
					<el-col :span="3" class='cate-box'>
						<div class="cate-tabbar" @mouseover="isShowGoodsCateLayer=true" @mouseleave="isShowGoodsCateLayer=false">
							<i class="el-icon-menu cate-ico"></i>
							<span class="cate-title" :class="goodsSearchParams.cateId>0?'checked-red':''">商品分类</span>
							<goods-cate class='goods-cate-layer' v-show="isShowGoodsCateLayer" v-on:select-cate="changeSearchGoodsCate"></goods-cate>
						</div>
					</el-col>
					<el-col :span="7">
						<search @searchGoods="changeSearchValue" :showPlaceholder="false"></search>
						<el-button plain @click="resetSearch" class="reset-search-btn">重置</el-button>
					</el-col>
				</el-row>
				<!-- 商品品牌 -->
				<div class='goods-brand' v-if="!isHiddenBrandList">
					<div class='all-brand' @click="changeSearchGoodsBrand(0)">全部品牌</div>
					<div class='brand-list' :class="isShowFullBrand?'show-full-brand':''">
						<span v-for="(item,index) in goodsBrandList" @click="changeSearchGoodsBrand(item.brandId)" :class="goodsSearchParams.brandId==item.brandId?'checked-red':''">{{item.brandNameCn}}</span>
					</div>
					<div class='brand-more' @click="isShowFullBrand=!isShowFullBrand">
						<span>{{isShowFullBrand?"收起":"更多"}}</span>
						<img class='more-ico' src="../../assets/images/ico-arrow-up-grey.svg" v-if="isShowFullBrand" />
						<img class='more-ico' src="../../assets/images/ico-arrow-down-grey.svg" v-else />
					</div>
				</div>
			</div>
		</div>
		<!-- 商品列表 -->
		<div class='goods-list-scroll' :style="{ height: goodsListHeight , top: goodsListTop}" ref="goodsListScrollContainer" @scroll="loadMoreGoodsList">
			<div class='goods-list'>
				<goods-item v-for="(item,index) in goodsList" :goodsInfo="item" class='goods-item' :isShowPrice='isShowPrice' @addShopCart="addShoppingCart"></goods-item>
				<div class='no-more'>{{goodsListIsPageEnd?"暂无更多数据":"加载中"}}</div>
			</div>
		</div>

		<!-- 右下角浮动按钮 -->
		<float-btns></float-btns>
	</div>
</template>
<script>
	import Search from '../../components/common/Search.vue';
	import GoodsCate from '../../components/goods/GoodsCate.vue';
	import WholeSaleGoodsItem from '../../components/goods/WholeSaleGoodsItem.vue';
	import FloatBtns from '../../components/common/FloatBtns.vue';

	import commonUtils from '../../utils/common-utlis.js';
	import {
		getParam
	} from '../../utils/api-utils/api-params.js';
	import {
		getCustomerInfo
	} from '../../utils/api-utils/api-customer.js';
	import goodsApi from '../../utils/api-utils/api-goods.js';

	export default {
		name: 'quickshopping',
		components: {
			'search': Search,
			'goods-cate': GoodsCate,
			'goods-item': WholeSaleGoodsItem,
			'float-btns': FloatBtns,
		},
		data() {
			return {
				mallLogo: "", // 商城Logo
				isHiddenBrandList: false, // 是否隐藏品牌列表
				isShowFullBrand: false, // 是否展示全部品牌
				isShowGoodsCateLayer: false, // 是否展示商品分类选择框
				goodsBrandList: [], // 商品品牌列表
				goodsSearchParams: { // 商品列表搜索内容项
					brandId: "",
					cateId: "",
					searchValue: "",
				},
				goodsPageInfo: { // 商品列表搜索翻页信息
					pageIndex: 1, // 页码（接口从1开始）
					pageSize: 50,
				},
				isLoadingGoodsList: false, // 是否正在加载商品列表
				goodsList: [], // 商品列表
				goodsListIsPageEnd: false, // 商品列表是否加载完毕
				shopcartCountList: [], // 购物车数量列表 
				goodsListScrollPosition: 0, // 记录页面滚动定位
				isShowPrice: false,
				goodsBuyRestrictionTypeMap: {
					trade: '每单',
					day: '每天',
					week: '每周',
					month: '每月',
				},
			}
		},
		created: async function() {
			// 加载配置参数
			await this._loadParams();
			// 加载品牌列表
			this._loadGoodsBrandList();
			// 加载商品列表
			this._loadGoodsList();
		},
		mounted() {
			// 监听顶部登录操作
			this.$eventBus.$on('setCustomerId', msg => {
				if (parseInt(msg) > 0) {
					// 加载品牌列表
					this._loadGoodsBrandList();
					// 重新加载商品列表
					this._searchGoodsList();
					// 加载购物车数量
					this._getShopcartCountGroupByGoods();
				}
				// 是否展示价格
				this.isShowPrice = this.$utils.getIsShowPrice()
			});
			// 是否展示价格
			this.isShowPrice = this.$utils.getIsShowPrice()
		},
		activated() {
			// 加载购物车数量
			this._getShopcartCountGroupByGoods();

			// 回到上次滚动位置
			this.$nextTick(() => {
				this.$refs.goodsListScrollContainer.scrollTop = this.goodsListScrollPosition;
			});
		},
		computed: {
			/**
			 * 总区域高度
			 */
			mainHeight() {
				// 返回屏幕高度减去200px的值
				return `${window.innerHeight - 50}px`;
			},

			/**
			 * 商品列表区域高度
			 */
			goodsListHeight() {
				// 返回屏幕高度减去200px的值
				return this.isHiddenBrandList ? `${window.innerHeight - 140}px` : `${window.innerHeight - 180}px`;
			},

			/**
			 * 商品列表区域top
			 */
			goodsListTop() {
				return this.isHiddenBrandList ? "74px" : "114px";
			}
		},
		watch: {
			/**
			 * 监听购物车数量变更
			 */
			shopcartCountList: {
				handler(newVal, oldVal) {
					let goodsList = this.goodsList;
					this._matchShopcartCount(goodsList, newVal);
					this.goodsList = goodsList;
				},
				deep: true
			}
		},
		beforeRouteLeave(to, from, next) {
			this.goodsListScrollPosition = this.$refs.goodsListScrollContainer.scrollTop;
			next();
		},
		methods: {
			/**
			 * 加载参数
			 */
			async _loadParams() {
				let paramList = await getParam("pcmall_title,pcmall_logo,isHiddenBrandList,goodsBuyRestrictionType,isOpenGoodsBuyRestriction");
				document.title = paramList.pcmall_title || "JMALL商城";
				this.mallLogo = paramList.pcmall_logo;
				this.isHiddenBrandList = paramList.isHiddenBrandList == "1";
				this.isOpenGoodsBuyRestriction = paramList.isOpenGoodsBuyRestriction == "1";
				this.goodsBuyRestrictionType = paramList.goodsBuyRestrictionType || 'trade';
			},

			/**
			 * 加载商品品牌列表
			 */
			_loadGoodsBrandList() {
				if (this.isHiddenBrandList) {
					return;
				}
				goodsApi.getGoodsBrandList().then(brandList => {
					this.goodsBrandList = brandList;
				});
			},

			/**
			 * 变更商品分类搜索
			 * @param {Object} cateInfo
			 */
			changeSearchGoodsCate(cateInfo) {
				this.goodsSearchParams.cateId = cateInfo.cateId;
				this._searchGoodsList();
			},

			/**
			 * 变更商品搜索关键字
			 * @param {Object} searchValue
			 */
			changeSearchValue(searchValue) {
				this.goodsSearchParams.searchValue = searchValue;
				this._searchGoodsList();
			},

			/**
			 * 变更商品品牌搜索
			 * @param {Object} brandId
			 */
			changeSearchGoodsBrand(brandId) {
				this.goodsSearchParams.brandId = brandId;
				this.isShowFullBrand = false;
				this._searchGoodsList();
			},

			/**
			 * 变更商品品牌搜索
			 * @param {Object} brandId
			 */
			resetSearch() {
				this.goodsSearchParams = {
					brandId: "",
					cateId: "",
					searchValue: "",
				};
				this._searchGoodsList();
			},

			/**
			 * 搜索商品列表
			 */
			_searchGoodsList() {
				// 需要清空页码和商品列表
				this.goodsPageInfo.pageIndex = 1;
				this.goodsList = [];
				this.goodsListIsPageEnd = false;
				// 刷新商品列表
				this._loadGoodsList();
			},

			/**
			 * 加载商品列表
			 */
			_loadGoodsList: commonUtils.debounce(async function() {
				// 显示加载中弹窗
				// let loadingLayer = this.$loading({
				// 	lock: true,
				// 	text: '加载中',
				// 	background: 'rgba(255, 255, 255, 0.2)'
				// });
				try {
					// 生成商品搜索条件
					let andConditions = {
						categoryIds: this.goodsSearchParams.cateId,
						isDistributorGoods: false,
						channelId: "0",
						isBlockUp: "0",
						brandId: this.goodsSearchParams.brandId
					};
					let orConditions = {
						fuzzyValue: this.goodsSearchParams.searchValue
					};

					// 获取商品数据
					let goodsList = await goodsApi.getGoodsRequest("brandName", this.goodsPageInfo.pageIndex, this.goodsPageInfo.pageSize, andConditions, orConditions, "ASC");

					// 补充完整的货品信息（价格、库存、营销活动信息等）
					goodsList = await goodsApi.completeFullGoodsInfoForList_noStock(goodsList, "goodsList");

					// 处理数据结构，生成组件所需数据
					goodsList = goodsList.map(t => {
						let unitInfoList = [];
						try {
							// 反序列化单位信息
							unitInfoList = JSON.parse(t.unitSetting);
						} catch (e) {}
						// 生成返回结果
						return {
							goodsId: t.goodsId,
							goodsName: t.goodsName,
							goodsPrice: t.priceMember || 0,
							score: t.score || 0,
							goodsImg: t.coverPic,
							baseUnitName: t.unit,
							unitInfoList,
							isMulti: t.isMulti == 1,
							isMultiUnit: unitInfoList && unitInfoList.length > 1,
							labelNameList: t.labelNameList,
							stock: t.stock || 0,
							activityId: t.activityId || 0,
							activityType: t.activityType || "",
							shoppingCartCount: 0,
							goodsType: t.goodsType,
							customerLimitCount: t.customerLimitCount,
							isOpenGoodsBuyRestriction: this.isOpenGoodsBuyRestriction,
							goodsBuyRestrictionTypeText: this.goodsBuyRestrictionTypeMap[this.goodsBuyRestrictionType],
						}
					});

					// 匹配商品列表的加购数量
					this._matchShopcartCount(goodsList, this.shopcartCountList);

					// 赋值商品数据
					this.goodsList = this.goodsList.concat(goodsList);
					this.goodsListIsPageEnd = goodsList.length < this.goodsPageInfo.pageSize;
				} catch (e) {
					console.log(e)
				} finally {
					// loadingLayer.close();
				}
			}, 500, false),

			/**
			 * 滚动加载更多商品
			 */
			loadMoreGoodsList() {
				// 检测商品列表是否全部加载完成，是则不再加载
				if (this.goodsListIsPageEnd) {
					return;
				}
				// 处理滚动加载
				this._handleScroll(this._loadMoreGoodsList());
			},

			/**
			 * 处理滚动触发
			 * @param {Object} callback
			 */
			_handleScroll(callback) {
				let scrollContainer = this.$refs.goodsListScrollContainer;
				let scrollTop = scrollContainer.scrollTop;
				let scrollHeight = scrollContainer.scrollHeight;
				let clientHeight = scrollContainer.clientHeight;

				// 触发距离
				let triggerDistance = 100;

				// 判断是否滚动至触发距离内
				if (scrollTop + clientHeight >= scrollHeight - triggerDistance) {
					callback && callback();
				}
			},

			/**
			 * 加载更多商品
			 */
			_loadMoreGoodsList: commonUtils.debounce(function() {
				console.log("加载商品")
				// 加载商品列表
				this.goodsPageInfo.pageIndex++;
				this._loadGoodsList();
			}, 300, true),

			/**
			 * 加入购物车
			 * @param {Object} catrList
			 */
			async addShoppingCart(catrList) {
				// 显示登录弹窗,可关闭
				let customerId = localStorage.getItem("pc_customerId");
				if (!customerId) {
					this.$eventBus.$emit("showLoginDialog", true, true);
					return;
				}

				// 加入购物车
				let cartIds = await goodsApi.addShoppingCartBatch(catrList);
				if (!cartIds) {
					this.$message.error('添加购车失败，请重试');
					return;
				}
				// 成功提示
				this.$message.success('添加成功，可前往购物车查看');
				// 刷新购物车数量
				this._getShopcartCountGroupByGoods();
				// 修改头部购物车总数
				this.$eventBus.$emit("updateHeaderShopCartCount");
			},

			/**
			 * 获取按商品维度统计的购物车数量
			 */
			async _getShopcartCountGroupByGoods() {
				let shopcartCountList = await goodsApi.getShopcartCountGroupByGoods();
				this.shopcartCountList = shopcartCountList;
			},

			/**
			 * 匹配商品列表的加购数量
			 * @param {Object} goodsList
			 * @param {Object} shopcartCountList
			 */
			_matchShopcartCount(goodsList, shopcartCountList) {
				if (!(goodsList.length > 0)) {
					return;
				}
				goodsList.forEach(goods => {
					let tmpCart = shopcartCountList.find(t => t.goodsId == goods.goodsId);
					if (tmpCart) {
						goods.shoppingCartCount = tmpCart.goodsCount;
					} else {
						goods.shoppingCartCount = 0;
					}
				});
			},
		}
	}
</script>
<style scoped>
	.main {
		min-height: 800px;
		color: #333;
	}

	.top-tabbar {
		background: #fff;
	}

	.top-tabbar-content {
		height: auto;
		padding: 0 7%;
		align-items: center;
		position: relative;
		background: #fff;
		z-index: 99;
		border-bottom: 1px solid #f9f9f9;
	}

	.top-tabbar .el-col {
		height: 74px;
		line-height: 74px;
		text-align: center;
		font-size: 16px;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
	}

	.mall-logo {
		height: 50px;
		margin: 15px auto;
		vertical-align: top;
	}

	.cate-box {
		position: relative;
	}

	.goods-cate-layer {
		position: absolute;
		top: 62px;
		left: -20px;
	}

	.cate-tabbar {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-items: center;
		line-height: 60px;
		height: 60px;
		cursor: pointer;
		min-width: 100px;
	}

	.cate-ico {
		font-size: 22px;
	}

	.cate-title {
		margin-left: 5px;
	}

	.search-box {
		height: 70px;
		line-height: 70px;
		position: relative;
	}

	.goods-brand {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		line-height: 32px;
		font-size: 15px;
		padding-bottom: 8px;
	}

	.all-brand {
		font-weight: bold;
		min-width: 100px;
		text-align: center;
		cursor: pointer;
	}

	.brand-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		flex-direction: row;
		height: 30px;
		overflow: hidden;
		width: 100%;
	}

	.show-full-brand {
		height: auto !important;
		overflow: unset !important;
	}

	.brand-list span {
		margin-right: 15px;
		cursor: pointer;
	}

	.brand-more {
		min-width: 64px;
		text-align: center;
		cursor: pointer;
	}

	.more-ico {
		width: 22px;
		height: 22px;
		vertical-align: top;
		margin: 4px 2px;
	}

	.checked-red {
		color: #ff2b2a !important;
	}

	.goods-list-scroll {
		overflow: auto;
		position: absolute;
		width: 100%;
		top: 114px;
		left: 0;
		padding-top: 15px;
	}

	.goods-list {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-content: flex-start;
		margin: auto;
		background: #ffffff;
		width: 80%;
		max-width: 1100px;
		min-width: 950px;
	}

	.goods-item {
		background: #ffffff;
		width: 50%;
		border-bottom: 1px solid #f9f9f9;
	}

	.no-more {
		width: 100%;
		text-align: center;
		padding: 15px 0;
		color: #aaa;
		font-size: 15px;
	}

	.top-tabbar-border {
		border-bottom: 1px solid #f1f1f1;
	}

	.reset-search-btn {
		margin-left: 10px;
	}
</style>